import { Navigate, useLocation, useParams } from 'react-router-dom';
import { LEGACY_STORE_HANDLES } from 'config/brand';

/** Rebrand: /zaynic[/<slug>] -> /rawaajmall[/<slug>] (query/hash kept). The
 * same redirect is a real 301 on Vercel (vercel.json) and in the storefront. */
export default function LegacyHandleRedirect({ children }) {
  const { storeHandle } = useParams();
  const location = useLocation();
  const next = storeHandle && LEGACY_STORE_HANDLES[storeHandle.toLowerCase()];
  if (!next) return children;
  const rest = location.pathname.slice(storeHandle.length + 1);
  return <Navigate replace to={`/${next}${rest}${location.search}${location.hash}`} />;
}
